export interface BillerModel {
    billerCodeId: string,
    ref1: string,
    ref2: string,
    registeredNumber: string,
    loanType : string,
    accountTypeName: string,
    fullAmount: string,
    minimumAmount: string,
    customAmount: string,
    channel: string,
    paymentDate: string,
    passdueDay: string,
    paymentTerm: string,
    chargeAmount: string,
    overDueStatus: string,
    billAmount: string,
    loanGroup: string
}


export const initBillerModel = () => {
    const model: BillerModel = {
        billerCodeId: '', ref1: '', ref2: '', registeredNumber: '', loanType: '',
        accountTypeName: '', fullAmount: "0.00", minimumAmount: "0.00", customAmount: "0.00", channel: '',
        paymentDate: '', passdueDay: '', paymentTerm: '', chargeAmount: '', overDueStatus: '', billAmount: "0.00", loanGroup: ''
    }

    return model
}

